/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/UserCompanyFunctionalityAccess'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/UserCompanyFunctionalityAccess'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserCompanyFunctionalityAccessApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.UserCompanyFunctionalityAccess);
  }
}(this, function(ApiClient, UserCompanyFunctionalityAccess) {
  'use strict';

  /**
   * UserCompanyFunctionalityAccess service.
   * @module api/UserCompanyFunctionalityAccessApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new UserCompanyFunctionalityAccessApi. 
   * @alias module:api/UserCompanyFunctionalityAccessApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the userCompanyFunctionalityAccessAddAllPut operation.
     * @callback module:api/UserCompanyFunctionalityAccessApi~userCompanyFunctionalityAccessAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/UserCompanyFunctionalityAccess>} body 
     * @param {module:api/UserCompanyFunctionalityAccessApi~userCompanyFunctionalityAccessAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.userCompanyFunctionalityAccessAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyFunctionalityAccessAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userCompanyFunctionalityAccessAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/UserCompanyFunctionalityAccess/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyFunctionalityAccessDeleteAllPut operation.
     * @callback module:api/UserCompanyFunctionalityAccessApi~userCompanyFunctionalityAccessDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/UserCompanyFunctionalityAccessApi~userCompanyFunctionalityAccessDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userCompanyFunctionalityAccessDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyFunctionalityAccessDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userCompanyFunctionalityAccessDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/UserCompanyFunctionalityAccess/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyFunctionalityAccessEditAllPut operation.
     * @callback module:api/UserCompanyFunctionalityAccessApi~userCompanyFunctionalityAccessEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/UserCompanyFunctionalityAccess>} body 
     * @param {module:api/UserCompanyFunctionalityAccessApi~userCompanyFunctionalityAccessEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userCompanyFunctionalityAccessEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyFunctionalityAccessEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userCompanyFunctionalityAccessEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/UserCompanyFunctionalityAccess/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyFunctionalityAccessLoadCurrentCompanyFunctionalityAccessesGet operation.
     * @callback module:api/UserCompanyFunctionalityAccessApi~userCompanyFunctionalityAccessLoadCurrentCompanyFunctionalityAccessesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/UserCompanyFunctionalityAccess>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadCurrentCompanyFunctionalityAccesses
     * @param {String} _4SAPIAppID 
     * @param {module:api/UserCompanyFunctionalityAccessApi~userCompanyFunctionalityAccessLoadCurrentCompanyFunctionalityAccessesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/UserCompanyFunctionalityAccess>}
     */
    this.userCompanyFunctionalityAccessLoadCurrentCompanyFunctionalityAccessesGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyFunctionalityAccessLoadCurrentCompanyFunctionalityAccessesGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [UserCompanyFunctionalityAccess];

      return this.apiClient.callApi(
        '/UserCompanyFunctionalityAccess/loadCurrentCompanyFunctionalityAccesses', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCompanyFunctionalityAccessToggleSmartStrategyAccessFunctionalityGet operation.
     * @callback module:api/UserCompanyFunctionalityAccessApi~userCompanyFunctionalityAccessToggleSmartStrategyAccessFunctionalityGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * toggleSmartStrategyAccessFunctionality
     * @param {String} _4SAPIAppID 
     * @param {Integer} functionalityID 
     * @param {Boolean} active 
     * @param {module:api/UserCompanyFunctionalityAccessApi~userCompanyFunctionalityAccessToggleSmartStrategyAccessFunctionalityGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userCompanyFunctionalityAccessToggleSmartStrategyAccessFunctionalityGet = function(_4SAPIAppID, functionalityID, active, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCompanyFunctionalityAccessToggleSmartStrategyAccessFunctionalityGet";
      }

      // verify the required parameter 'functionalityID' is set
      if (functionalityID == undefined || functionalityID == null) {
        throw "Missing the required parameter 'functionalityID' when calling userCompanyFunctionalityAccessToggleSmartStrategyAccessFunctionalityGet";
      }

      // verify the required parameter 'active' is set
      if (active == undefined || active == null) {
        throw "Missing the required parameter 'active' when calling userCompanyFunctionalityAccessToggleSmartStrategyAccessFunctionalityGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'functionalityID': functionalityID,
        'active': active
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/UserCompanyFunctionalityAccess/toggleSmartStrategyAccessFunctionality', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
